<template>
    <div class="product-shop-wrapper">
        <h4 v-if="recipeDetails && recipeDetails.recipeInfo.recipeName" class="input-title"> {{ recipeDetails.recipeInfo.recipeName }} </h4>
<!--        <p v-if="recipeDetails && recipeDetails.recipeInfo.observation" class="input-description" id="submissionDescription">
            {{ recipeDetails.recipeInfo.observation }}
        </p>-->
        <h4 v-if="textBody && textBody.title" class="input-title"> {{ textBody.title }} </h4>
        <p v-if="textBody && textBody.description" class="input-description" id="submissionDescription">
            {{ textBody.description }}
        </p>
        <div v-if="(recipeDetails || (textBody && textBody.description) && isTextClamped)" class="read-more-wrapper" @click.prevent="modalControl(true, modalAction)">
            <i class="ecom-chevron-right"/>
            <span class="text"> {{ kStrings.kREAD_MORE }} </span>
        </div>
        <h4 v-if="productList" class="input-title"> {{ kStrings.kUSED_PRODUCTS + ':' }} </h4>
        <div v-if="productList" class="product-shop-list themed-scrollbar">
            <div v-for="item in productList" class="shop-item" :id="'shop-item-' + item.groupId">
                <img :src="item.img" class="item-img" :alt="item.name"/>
                <div class="mx-0 item-info-container">
                    <div class="prod-labels" :class="{ 'col px-0' : isDesktop }">
                        <a target="_blank" :href="item.url" class="item-label name-label prod-link clamp" data-mub-skip="y"> {{ item.name }} </a>
                        <p class="item-label light variant-label clamp"> {{ item.label }} </p>
                        <p v-if="!isDesktop" class="item-label light qty-label"> {{ kStrings.kQUANTITY + ': ' }} <span> {{ item.qty }} </span> </p>
                    </div>
                    <div class="price-labels" :class="{ 'col-3 pr-0' : isDesktop }">
                        <span class="item-label"> {{ item.price }} </span>
                        <span v-if="item.priceUnit" class="item-label light"> {{ item.priceUnit + '/ unit' }} </span>
                    </div>
                    <div class="action-labels" :class="{ 'col-12 px-0 mt-auto' : isDesktop }">
                        <p v-if="isDesktop" class="item-label light qty-label"> {{ kStrings.kQUANTITY + ': ' }} <span> {{ item.qty }} </span> </p>
                        <span v-if="item.canBuy" class="item-label url-label" @click="loadMultiCart(item.groupId)"> {{ kStrings.kADD_TO_CART }} </span>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="buttonAddAllEnabled" class="button-wrapper">
            <button class="pastime-button light" @click="loadMultiCart()" data-mub-skip="y"> {{ kStrings.kADD_ALL_TO_CART }} </button>
        </div>
        <div v-if="isDesktop" class="button-wrapper">
            <button class="pastime-button" @click.prevent="goToLink(urls.pastimeUrl)" data-mub-skip="y"> {{ kStrings.kVIEW_PASTIME }} </button>
        </div>
        <MultiCartPopup v-if="multiCartData" :multi-cart-data="multiCartData" :web-event-value="'PASTIMES_CART'" @close="multiCartData = null"/>
    </div>
</template>

<script>

import {store} from '@/store/pastimes';
import {isEmpty} from 'lodash-es';

import apiCart from '@/api/cart';

import MultiCartPopup from '@/components/MultiCart/MultiCartPopup.vue';
import request from '@/Utilities/httpRequest';
import utilities from '@/Utilities/common';

export default {
    store,
    name: 'ProductShop',
    components: {
        MultiCartPopup
    },
    props: {
        //prop1: {type: Object, default: null, required: false},
    },
    data() {
        return {
            isTextClamped: true,
            multiCartData: null
        };
    },
    computed: {
        isDesktop() {
            return this.$store.getters.isDesktop;
        },
        urls() {
            return this.$store.getters.urls;
        },
        isLoading() {
            return this.$store.getters.loading;
        },
        kStrings() {
            return this.$store.getters.kStrings;
        },
        notificationData() {
            return this.$store.getters['contestantPage/notificationData'];
        },
        registrationInfo() {
            return this.$store.getters['contestantPage/registrationInfo'];
        },
        textBody() {
            return !isEmpty(this.registrationInfo.textBody) ? this.registrationInfo.textBody : null
        }, 
        recipeDetails() {
            return !isEmpty(this.registrationInfo.recipeDetails) ? this.registrationInfo.recipeDetails : null
        },
        productList() {
            return !isEmpty(this.registrationInfo.productListDetailed) ? this.registrationInfo.productListDetailed : null;
        },
        modalStatus() {
            return this.$store.getters.modalStatus;
        },
        modalAction() {
            return this.recipeDetails ? 'recipeDescription' : 'textBodyDescription';
        },
        allSkusToAdd() {
            let list = [];
            const products = this.productList;
            if(products){
                for(let i=0; i<products.length; i++){
                    if(!products[i].canBuy){
                        continue;
                    }
                    list.push({
                        sku: products[i].sku,
                        quantity: products[i].qty,
                        type: 0,
                        addQty: true,
                    });
                }
            }
            return list;
        },
        buttonAddAllEnabled(){
            if(this.productList && this.productList.length > 1){
                for(let i = 0; i < this.productList.length; i++){
                    if(this.productList[i].canBuy){
                        // at least one product can be bought
                        return true;
                    }
                }
            }
            return false;
        }
    },
    watch: {
        multiCartData(value) {
            if(!this.isDesktop) {
                //console.log('app event: ', value != null);
                utilities.eventModalApp(value != null);
            }
        }
    },
    created() {
    },
    mounted() {
        this.$nextTick(() => {
            let submissionDescription = document.getElementById('submissionDescription');
            if(submissionDescription) {
                this.isTextClamped = submissionDescription.scrollHeight > submissionDescription.clientHeight;
            }
        });
    },
    methods: {
        // a little "repetition"....
        modalControl(status = false, context = '') {
            this.$store.dispatch('setModalStatus', {status: status, context: context});
        },
        async addProductsToCart(sku = 0, qty = 0, type = 0) {
            try {
                this.$store.dispatch('setLoading', true);
                const {data} = !sku ? await apiCart.addToCartBulk(this.allSkusToAdd, 0) : await apiCart.addToCart(sku, qty, type);
                console.log('cart response: ', response);
                let hasError = !data || data.error;
                if(!hasError) {
                    let numCartItems = data.cart.itemCount;
                    if (numCartItems) {
                        if (this.isDesktop) {
                            VueEs6.addToCartDesktop.cartItemNumUpdate(numCartItems);
                            VueEs6.header.miniCart.updateAndOpen();
                            this.$store.dispatch('contestantPage/loadNotification', {
                                type: 'success',
                                text: this.kStrings.kCART_UPDATE_SUCCESS
                            });
                        } else {
                            // mobile incomplete
                            VueEs6.addToCart.cartItemNumUpdate(numCartItems);
                            let responseError = data.error;
                            const success = !responseError ? true : false;
                            const message = !responseError
                                ? this.kStrings.kCART_UPDATE_SUCCESS
                                : this.kStrings.kSOMETHING_WRONG;

                            this.$store.dispatch('contestantPage/loadNotification', {
                                type: success,
                                text: message
                            });
                        }
                    } else {
                        this.$store.dispatch('contestantPage/loadNotification', {
                            type: 'error',
                            text: this.kStrings.kSOMETHING_WRONG
                        });
                        
                    }
                } else {
                    this.$store.dispatch('contestantPage/loadNotification', {
                        type: 'error',
                        text: response.data.message
                    });
                }
                
                this.$store.dispatch('setLoading', false);
            } catch (error) {
                console.log('cart has errors, please try another time :(', error);
                this.$store.dispatch('setLoading', false);
                this.$store.dispatch('contestantPage/loadNotification', {
                    type: 'error',
                    text: this.kStrings.kSOMETHING_WRONG
                });
            }
        },
        goToLink(link) {
            if(link) {
                window.location.assign(link);
            }
        },
        async loadMultiCart(groupId = null) {
            try {
                this.$store.dispatch('setLoading', true);
                let params = {
                    groupIdList: !groupId ? this.productList.map(elm => elm.canBuy ? elm.groupId : null).filter(e => e) : [groupId],
                };
                const {data} = await request.post(this.urls.multiCart, params,false);
                //console.log('multiCart response: ', data);
                let hasError = !data || data.hasOwnProperty('error') || data.error;
                if(!hasError) {
                    this.multiCartData = data;
                } else {
                    this.$store.dispatch('contestantPage/loadNotification', {
                        type: 'error',
                        text: this.kStrings.kSOMETHING_WRONG
                    });
                }
            } catch (error) {
                this.$store.dispatch('contestantPage/loadNotification', {
                    type: 'error',
                    text: this.kStrings.kSOMETHING_WRONG
                });
            } finally {
                this.$store.dispatch('setLoading', false);
            }
            
        }
    },
};
</script>

<style scoped>

</style>
